import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "add-to-cart-counter p-0" }

import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'QuantityCounter',
  setup(__props) {

const internalValue = ref<number>(1);

const increment = () => {
  internalValue.value++;
};

const decrement = () => {
  if (internalValue.value > 0) {
    internalValue.value--;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      type: "button",
      class: "minusBtn bg-transparent position-relative for-dark-cart",
      style: {"color":"#666666","font-size":"30px","height":"31px","top":"-2px","width":"30px"},
      onClick: decrement,
      value: "-"
    }),
    _withDirectives(_createElementVNode("input", {
      type: "text",
      size: "25",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
      class: "count bg-body-bg border-0",
      style: {"max-width":"30px"}
    }, null, 512), [
      [_vModelText, internalValue.value]
    ]),
    _createElementVNode("input", {
      type: "button",
      class: "plusBtn bg-transparent",
      style: {"color":"#666666","font-size":"20px","height":"31px","width":"30px"},
      onClick: increment,
      value: "+"
    })
  ]))
}
}

})